import React from 'react'
import PropTypes from 'prop-types'

import { values } from 'lodash'
import classes from 'classnames'

import { ui } from '../redux'

import FormGroup from '../components/FormGroup'

const Input = (props) => {
    const {
        label, input, meta, description, size, isHidden, isHorizontal, ...otherProps
    } = props
    const { name } = input
    const { error } = meta
    return (
        <FormGroup
            name={ name }
            label={ !isHidden ? label : null }
            error={ error }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            <input
                id={ name }
                type={ isHidden ? 'hidden' : 'text' }
                className={ classes('form-control', `input-${size}`) }
                { ...otherProps }
                { ...input }
            />
        </FormGroup>
    )
}

Input.propTypes = {
    label        : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    description  : PropTypes.string,
    size         : PropTypes.oneOf(values(ui.SIZE)),
    isHidden     : PropTypes.bool,
    isHorizontal : PropTypes.bool
}

Input.defaultProps = {
    size         : 'default',
    isHidden     : false,
    isHorizontal : false
}

export default Input
